import HomePage from '@/Pages/HomePage/HomePage'
import React from 'react'

type Props = {}

const BaseLayout = (props: Props) => {
  return (
    <HomePage/>
  )
}

export default BaseLayout